// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-container-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    background: #f8f9fa;
    min-height: 100vh;
}

.terms-header-main {
    text-align: center;
    margin-bottom: 1.5rem;
}

.terms-header-main h1 {
    font-size: 2rem;
    color: #333;
    margin-bottom: 0.5rem;
}

.terms-header-main p {
    font-size: 1.1rem;
    color: #555;
}

.terms-viewer-main {
    position: relative;
    width: 80%;
    height: 70vh;
    background: white;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;  
}

.pdf-frame-main {
    width: 100%;
    height: 100%;
    border: none;
    pointer-events: auto;  
}

.terms-actions-main {
    margin-top: 1.5rem;
    display: flex;
    gap: 15px;
}

.download-btn-main, .back-btn-main {
    padding: 10px 20px;
    font-size: 1rem;
    border-radius: 5px;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.3s ease;
}

.download-btn-main {
    background: #007bff;
    color: white;
    border: none;
}

@media print {
    body {
        display: none !important;
    }
}

.terms-actions-main {
    margin-top: 1.5rem;
    display: flex;
    justify-content: center;
}

.back-btn-main {
    padding: 10px 20px;
    font-size: 1rem;
    border-radius: 5px;
    background: #6c757d;
    color: white;
    border: none;
    cursor: pointer;
    transition: background 0.3s ease;
}

.back-btn-main:hover {
    background: #5a6268;
}

@media (max-width: 768px) {
    .terms-container-main {
        padding: 2rem;
    }

    .terms-viewer-main {
        width: 100%;
        height: 60vh;
    }

    .terms-actions-main {
        flex-direction: column;
        width: 100%;
    }

    .download-btn-main, .back-btn-main {
        width: 100%;
        text-align: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Terms/TermsPageSingle.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ","sourcesContent":[".terms-container-main {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 3rem;\n    background: #f8f9fa;\n    min-height: 100vh;\n}\n\n.terms-header-main {\n    text-align: center;\n    margin-bottom: 1.5rem;\n}\n\n.terms-header-main h1 {\n    font-size: 2rem;\n    color: #333;\n    margin-bottom: 0.5rem;\n}\n\n.terms-header-main p {\n    font-size: 1.1rem;\n    color: #555;\n}\n\n.terms-viewer-main {\n    position: relative;\n    width: 80%;\n    height: 70vh;\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;  \n}\n\n.pdf-frame-main {\n    width: 100%;\n    height: 100%;\n    border: none;\n    pointer-events: auto;  \n}\n\n.terms-actions-main {\n    margin-top: 1.5rem;\n    display: flex;\n    gap: 15px;\n}\n\n.download-btn-main, .back-btn-main {\n    padding: 10px 20px;\n    font-size: 1rem;\n    border-radius: 5px;\n    text-decoration: none;\n    cursor: pointer;\n    transition: background 0.3s ease;\n}\n\n.download-btn-main {\n    background: #007bff;\n    color: white;\n    border: none;\n}\n\n@media print {\n    body {\n        display: none !important;\n    }\n}\n\n.terms-actions-main {\n    margin-top: 1.5rem;\n    display: flex;\n    justify-content: center;\n}\n\n.back-btn-main {\n    padding: 10px 20px;\n    font-size: 1rem;\n    border-radius: 5px;\n    background: #6c757d;\n    color: white;\n    border: none;\n    cursor: pointer;\n    transition: background 0.3s ease;\n}\n\n.back-btn-main:hover {\n    background: #5a6268;\n}\n\n@media (max-width: 768px) {\n    .terms-container-main {\n        padding: 2rem;\n    }\n\n    .terms-viewer-main {\n        width: 100%;\n        height: 60vh;\n    }\n\n    .terms-actions-main {\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .download-btn-main, .back-btn-main {\n        width: 100%;\n        text-align: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
